// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"; 
import { getFirestore, collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBw58y-x16MbBSnz4uddvwEF-vsPOyHABo",
  authDomain: "reekariyer-8d127.firebaseapp.com",
  projectId: "reekariyer-8d127",
  storageBucket: "reekariyer-8d127.appspot.com",
  messagingSenderId: "355795245140",
  appId: "1:355795245140:web:dcbd59f31df982aa8635c1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
export { auth , db, collection, getDocs, doc, updateDoc, storage};

